import {z} from 'zod';
import {LabelValueSchema} from '@netx/core-next/schema';

export const PublicPropertySchema = LabelValueSchema.extend({});

export type IPublicProperty = z.infer<typeof PublicPropertySchema>;
